import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import userReducer from './reducer';



export const store = configureStore({
  reducer: userReducer,
  middleware:(getDefaultMiddleware)=>getDefaultMiddleware(),
});



export default store;